var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", {}, [
    _c(
      "div",
      { staticClass: "d-flex justify-content-between align-items-center mb-3" },
      [
        _c("div", {}, [
          _c(
            "div",
            {
              staticClass: "badge badge-status badge-status-sm",
              style: {
                color: _vm.item.status.color,
                "background-color": _vm.$root.$helper.color.convertHex(
                  _vm.item.status.color
                ),
              },
            },
            [_c("span", [_vm._v(_vm._s(_vm.item.status.name))])]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "d-flex" }, [
          _c("div", {}, [
            _c(
              "button",
              {
                staticClass:
                  "btn btn-link shadow-none text-decoration-none text-nowrap p-0 m-0",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.selectFeature(_vm.item)
                  },
                },
              },
              [
                _c("span", { staticClass: "text-btn-link pl-2 pl-sm-3" }, [
                  _vm._v(_vm._s(_vm.$t(_vm.txtLinkMap))),
                ]),
              ]
            ),
          ]),
        ]),
      ]
    ),
    _vm._v(" "),
    _vm.item.type
      ? _c("div", { staticClass: "title" }, [
          _vm._v("\n    " + _vm._s(_vm.item.type.name) + "\n  "),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "row no-gutters" }, [
      _c("div", { staticClass: "col" }, [
        _c("div", { staticClass: "form-group" }, [
          _c("p", { staticClass: "label" }, [
            _vm._v(
              "\n          " + _vm._s(_vm.$t(_vm.labelCode)) + "\n        "
            ),
          ]),
          _vm._v(" "),
          _c("p", [_vm._v(_vm._s(_vm.item.code))]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col" }, [
        _c("div", { staticClass: "form-group" }, [
          _c("p", { staticClass: "label" }, [
            _vm._v(
              "\n          " + _vm._s(_vm.$t(_vm.labelCreatedAt)) + "\n        "
            ),
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              _vm._s(
                _vm
                  .moment(_vm.item.created_at, "YYYY-MM-DD hh:mm:ss")
                  .format("DD-MM-YYYY")
              )
            ),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row no-gutters" }, [
      _c("div", { staticClass: "col" }, [
        _c("div", { staticClass: "form-group" }, [
          _c("p", { staticClass: "label" }, [
            _vm._v(
              "\n          " + _vm._s(_vm.$t(_vm.labelAddress)) + "\n        "
            ),
          ]),
          _vm._v(" "),
          _c("p", [_vm._v(_vm._s(_vm.item.address))]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }